import React from "react";
import UploadForm from "../components/UploadForm";

const PurchaseOrderUpload = (props) => {
  return <UploadForm {...props} type="purchase_order" />;
}

export default PurchaseOrderUpload;



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/PurchaseOrderUpload.js